import { Body, Heading } from 'components/text';
import { FC } from 'react';
import styles from './Testimonial.module.scss';
import Carousel from 'react-material-ui-carousel';
import { ArrowLeft, ArrowRight, QuotationMark } from 'components/icons';
import { MylerTestimonials } from '../contants';
import Container from 'components/container';

const Testimonials: FC<{}> = ({}) => {
  return (
    <Container className={styles.container} as="section">
      <Container className={styles.wrapper}>
        <Heading as="h4" align="center">
          MyLER Testimonials
        </Heading>
        <Container className={styles.questionMark}>
          <QuotationMark />
        </Container>
        <Container mt={30}>
          <Carousel
            className={styles.carousel}
            autoPlay={false}
            animation={'slide'}
            navButtonsAlwaysVisible={true}
            navButtonsWrapperProps={{
              className: styles.navPosition,
            }}
            NextIcon={
              <div className={styles.rightArrow}>
                <ArrowRight />
              </div>
            }
            PrevIcon={
              <div className={styles.leftArrow}>
                <ArrowLeft />
              </div>
            }
            indicators={false}
            height={425}
            navButtonsProps={{
              style: { backgroundColor: 'transparent', borderRadius: 0 },
            }}
          >
            {MylerTestimonials.map((item, i) => (
              <Container
                key={i}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <Container className={styles.testimonialWrapper}>
                  {item.testimonial?.map((text, index) => {
                    return (
                      <Body className={styles.testimonial} key={index}>
                        {text}
                      </Body>
                    );
                  })}
                </Container>
                <Container className={styles.testimonialName} mt={30}>
                  <Body
                    className={styles.name}
                    weight="demiBold"
                    color="grey-dark"
                  >
                    {item.name}
                  </Body>
                  <Body
                    className={styles.tier}
                    weight="demiBold"
                    color="grey-dark"
                  >
                    {item.tier} since {item.year}
                  </Body>
                </Container>
              </Container>
            ))}
          </Carousel>
        </Container>
      </Container>
    </Container>
  );
};

export default Testimonials;
